type Result<T, E = Error> = [T, null] | [null, E];

/**
 * Wraps a promise in a try/catch block and returns a
 * result object with a discriminated union.
 */
export async function tryCatch<T, E = Error>(
  promise: T | Promise<T>,
): Promise<Result<T, E>> {
  try {
    const data = await promise;

    return [data, null];
  } catch (error) {
    return [null, error as E];
  }
}

/**
 * Sync version of tryCatch.
 */
export function tryCatchSync<T, E = Error>(fn: () => T): Result<T, E> {
  try {
    const data = fn();

    return [data, null];
  } catch (error) {
    return [null, error as E];
  }
}
